import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface ICRMAuthUrlPayload extends ISagaCb {
    typeName: string
}

export interface ICRMAuthUrl {
    status: string
    data: any
    errors: any
}

const initialState: ICRMAuthUrl = {
    status: STATUS.IDLE,
    data: {},
    errors: null
}

const CRMAuthUrl = createSlice({
    name: 'crm/auth-url',
    initialState,
    reducers: {
        onRequest(state, actions: PayloadAction<ICRMAuthUrlPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const CRMAuthUrlActions = CRMAuthUrl.actions
export default CRMAuthUrl.reducer
